import React from 'react';
import { inject, observer } from 'mobx-react';
import { Formik } from 'formik';

import FormFields from './ShiftFormFields';
import ShiftFormScheme from './ShiftFormScheme';
import defaultFormatDate from "../utils/defaultFormatDate";

const ShiftForm = inject('shiftStore', 'employeeStore', 'planStore')(
  observer(
    class ShiftForm extends React.Component {
      /**
       * @param {object} props
       * @return void
       */
      constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);

        this.state = {
          startDate: typeof props.values.startDate !== 'undefined' ?
            props.values.startDate :
            null,
          employees: props.employeeStore.employees,
        };
      }

      componentDidMount() {
        this.getCapacity(this.state.startDate);
      }

      /**
       * Get capacity for employees
       *
       * @param  {array} shifts
       * @return {object}
       */
      getCapacity(date) {
        this.props.employeeStore.fetchEmployees(defaultFormatDate(date))
          .then(() => {
            this.setState({
              employees: this.props.employeeStore.employees,
            })
          });
      }

      /**
       * Handle the submit on the form
       *
       * @param {object} values
       * @param {object} actions
       * @return {void}
       */
      onSubmit(values, actions) {
        this.props.shiftStore.submitShift(values)
          .then(() => {
            actions.setSubmitting(false);
          })
          .catch((err) => {
            console.error(err);
            actions.setSubmitting(false);
          });
      }

      /**
       * Render form element and fields
       *
       * @param props
       * @returns {React.Component}
       */
      renderForm(props) {
        return (
          <form onSubmit={props.handleSubmit}>
            <FormFields employeesList={this.state.employees} {...props} />
          </form>
        );
      }

      /**
       * Render Formik component
       *
       * @returns {React.Component}
       */
      render() {
        const defaultValues = {
          id: '',
          shiftName: '',
          projectName: '',
          projectIdentifier: '',
          startDate: '',
          startDateTime: '09:00',
          endDate: '',
          endDateTime: '16:00',
          employees: [],
          contractor: '',
          requiredUsers: 0,
        };

        return (
          <Formik
            initialValues={Object.assign(defaultValues, this.props.values)}
            values={Object.assign(defaultValues, this.props.values)}
            onSubmit={this.onSubmit}
            render={this.renderForm}
            validationSchema={ShiftFormScheme}
          />
        );
      }
    }
  )
);

export default ShiftForm;



// WEBPACK FOOTER //
// ./src/forms/ShiftForm.js